import Avery from '@averyano/core';

import { Detection } from './classes/Detection';

import NodeEmitter from './classes/NodeEmitter';
import CookieBanner from './components/CookieBanner';

import Navigation from './components/Navigation';
import Preloader from './components/@avery-loader/Preloader';

import Lenis from '@studio-freight/lenis';

import { debounce, requestIdleCallbackPolyfill } from './utils/utils';
import ScrollTrigger from 'gsap/all';
console.log(FN_URL);
// Pages
import StorePage from './pages/Store';
import ProductViewPage from './pages/ProductViewPage';
import NotFound from './pages/NotFound';
import Footer from './components/Footer';
import PolicyPage from './pages/Policy';
import HomePage from './pages/Home';
import ConfirmationPage from './pages/Confirmation';

import CartController from './components/OnlineStore/cart-controller';
import CartPopup from './components/OnlineStore/CartPopup';
import WishlistPopup from './components/OnlineStore/WishlistPopup';
import ShoppingPopup from './components/OnlineStore/ShoppingPopup';
import CheckoutPopup from './components/OnlineStore/CheckoutPopup';
import CartBagElement from './components/OnlineStore/CartBagElement';
import LangPopup from './components/LangPopup';

import each from 'lodash/each';
// import data from '../locales/en.json';
// console.log(data);
import posthog from 'posthog-js';
// console.log(STORECOUNTRIES);
// import { initializeApp } from 'firebase/app';
// import { getFirestore, collection, getDocs } from 'firebase/firestore';
// import { getAuth, signInAnonymously, onAuthStateChanged } from 'firebase/auth';

// const firebaseConfig = {
// 	apiKey: 'AIzaSyDSiH7fG7owpofUP3ASl8drtqhy7cANdWk',
// 	authDomain: 'averyano-2023.firebaseapp.com',
// 	projectId: 'averyano-2023',
// 	storageBucket: 'averyano-2023.firebasestorage.app',
// 	messagingSenderId: '973203353428',
// 	appId: '1:973203353428:web:5527f41fb3f28a7c15a2c1',
// 	measurementId: 'G-MWZVYTK0KG',
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const db = getFirestore(app);
// const auth = getAuth(app);

// signInAnonymously(auth)
// 	.then(() => {
// 		console.log('Signed in anonymously');
// 		getDocs(collection(db, 'order')).then((snapshot) => {
// 			const orders = [];
// 			snapshot.forEach((doc) => orders.push(doc.data()));
// 			console.log(orders);
// 		});
// 	})
// 	.catch((error) => {
// 		console.error('Auth failed:', error);
// 	});

// async function getOrder() {
// 	return getDocs(collection(db, 'order'))
// 		.then((querySnapshot) => {
// 			const orders = [];
// 			querySnapshot.forEach((doc) => {
// 				orders.push(doc.data());
// 			});
// 			return orders;
// 		})
// 		.catch((error) => {
// 			console.error('Error getting documents: ', error);
// 			return [];
// 		});
// }
// const o = await getOrder();
// console.log(o);
window.locale = 'ua';
class App {
	constructor() {
		this.getCurrentLocale();

		this.isCreated = false;
		this.scrollOnLoad = null;
		this.create();
		this.createContent();
		this.createNavigation();
		this.createPreloader();
		this.registerNodeEvents();
	}

	create() {
		requestIdleCallbackPolyfill();

		// Scroll
		this.scroll = new Lenis({
			syncTouch: true,
			// easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
		});

		// this.scroll.on('scroll', ScrollTrigger.update);
		// this.scroll.on('scroll', (e) => console.log(e));
		// Canvas

		// Other
		this.addEventListeners();
		this.update();
	}

	createPreloader() {
		this.avery = new Avery({
			detection: Detection,
			loader: {
				pages: this.pages,
				preloader: this.preloader,
				onLeave: async () => {
					await this.preloader.show();
					this.scroll.destroy();
					this.footer.destroy();

					this.navigation.closeAll();
					this.avery.$emit('hideMenu');

					// kill all ScrollTrigger instances
					// ScrollTrigger.getAll().forEach((instance) => instance.kill());
				},
				beforeEnter: () => {
					console.log(`Before Enter ${this.avery.loader.template}`);
					this.preloader.selectorChildren.images =
						this.avery.loader.router.content.images;
					this.preloader.createComponent();
					this.preloader.createLoader(this.avery.loader.template);
				},
				onEnter: () => {
					// GlobalHandler.setTemplate = this.loader.template;
				},

				afterEnter: () => {
					this.scroll = new Lenis();

					this.scroll.scrollTo('top');
					this.footer.create();

					// if (this.loader.template === 'home') {
					// 	NodeEmitter.emit('hideMenu');
					// } else {
					// }
				},
				onPreloaded: async () => {
					console.log('CURRENT:', this.avery.loader.current.page);
					document.body.classList.remove('refresh');

					await this.avery.loader.current.page.show();
					this.avery.$emit('showMenu');

					this.navigation.updateNav(this.avery.loader.template);

					// this.footer.show();
					this.preloader.hide();
					this.onResize();

					// if (
					// 	this.avery.loader.template === 'store' ||
					// 	this.avery.loader.template === 'productview'
					// ) {
					// 	each(this.avery.loader.current.page.components, (component) => {
					// 		if (component.createMarq) component.createMarq();
					// 	});
					// }

					console.log(this.avery.loader.template);
					console.log('onPreloaded');
				},
			},
		});
		window.isMobile =
			this.avery.detection.isMobile || this.avery.detection.isTablet;
		// Loader
		this.id = document.querySelector('[data-page]').dataset.page;
		console.log('ID', this.id);
		if (this.id === 'home') {
			this.preloader.createLoader('home');
		}
		if (this.id === 'store') {
			this.preloader.createLoader('store');
		}
		if (this.id === 'productview') {
			this.preloader.createLoader('productview');
		}
		if (this.id === '404') {
			this.preloader.createLoader('notfound');
		}
		if (this.id === 'privacy-policy') {
			this.preloader.createLoader('privacy-policy');
		}
		if (this.id === 'refund-policy') {
			this.preloader.createLoader('refund-policy');
		}
		if (this.id === 'user-agreement') {
			this.preloader.createLoader('user-agreement');
		}
		if (this.id === 'confirmation') {
			this.preloader.createLoader('confirmation');
		}
		if (!this.id) {
			this.preloader.createLoader('404');
		}

		console.log(this.avery);
		this.avery.start();
		this.avery.$on('scrollTo', (e) => {
			// e looks like '.awards'

			// const value = document.querySelector(e).getBoundingClientRect().top;
			if (this.scroll) this.scroll.scrollTo(e);
		});

		this.avery.$on('scrollOnLoad', (e) => {
			this.scrollOnLoad = e;
		});
	}

	createNavigation() {
		this.navigation = new Navigation();

		if (this.id !== 'home') this.navigation.show();
	}

	createContent() {
		this.preloader = new Preloader();
		this.mainDiv = document.querySelector('.main-div');

		// Pages
		this.home = new HomePage('.home');
		this.notfound = new NotFound('.notfound');
		this.store = new StorePage('.store');
		this.productview = new ProductViewPage('.productview');
		this.privacyPage = new PolicyPage('.policy', 'privacy-policy');
		this.refundPage = new PolicyPage('.policy', 'refund-policy');
		this.offerPage = new PolicyPage('.policy', 'user-agreement');
		this.confirmationPage = new ConfirmationPage('.confirmation');
		// Popups
		this.cartPopup = new CartPopup();
		this.cartPopup.create();
		this.wishlistPopup = new WishlistPopup();
		this.wishlistPopup.create();
		this.shoppingPopup = new ShoppingPopup();
		this.shoppingPopup.create();
		this.checkoutPopup = new CheckoutPopup();
		this.checkoutPopup.create();
		this.cartBagElement = new CartBagElement();
		this.cartBagElement.create();
		this.langPopup = new LangPopup();
		this.langPopup.create();

		// Routing
		this.pages = [
			{ page: this.home, url: ['/', '/home'] },
			{ page: this.notfound, url: '/404' },
			{ page: this.store, url: '/store' },
			{
				page: this.productview,
				url: '/store/:id',
				pointer: 'id',
				data: STOREPRODUCTS[window.locale], // [{ id }, { id }, ..., { id }]
			},
			{ page: this.privacyPage, url: '/privacy-policy' },
			{ page: this.refundPage, url: '/refund-policy' },
			{ page: this.offerPage, url: '/user-agreement' },
		];

		this.pageLength = this.mainDiv.getBoundingClientRect().height;
		this.isCreated = true;

		// Components
		this.footer = new Footer();
		this.footer.create();

		this.cookieBanner = new CookieBanner();
		this.cookieBanner.on('analytics:initialize', () => {
			console.log('analytics:initialize');

			const cookieAllowed = localStorage.getItem('cookieAllowed');
			window.cookiedAllowed = cookieAllowed === 'true';

			posthog.init('phc_Nk2GVFzyWGNxzfn5KtC9EjcTecWAc2EFH92ynhOVI8d', {
				api_host: 'https://eu.i.posthog.com',
				person_profiles: 'always', // or 'always' to create profiles for anonymous users as well
				// debug: true,
			});
			posthog.set_config({
				persistence: 'localStorage+cookie', // 'memory' when not allowed?
			});
			// posthog.opt_in_capturing();
		});
		this.cookieBanner.on('analytics:reject', () => {
			// posthog.opt_out_capturing();

			console.log('analytics:reject');
		});
	}

	registerNodeEvents() {
		this.avery.$on('openMenu', () => {
			this.navigation.openMenu();
		});

		this.avery.$on('closeMenu', () => {
			this.navigation.closeMenu();
		});

		this.avery.$on('showLangPopup', () => {
			this.langPopup.show();
		});
		this.avery.$on('showMenu', () => {
			this.navigation.show();
		});
		this.avery.$on('hideMenu', () => this.navigation.hide());

		this.avery.$on('stopScroll', () => this.scroll.stop());
		this.avery.$on('startScroll', () => this.scroll.start());

		this.avery.$on('addToCart', (product, isQuickBuy) => {
			CartController.addToCart(product);
			this.cartBagElement.updateUi();
			if (isQuickBuy) return this.avery.$emit('viewCheckout');

			this.cartPopup.insertProduct(product);
			this.cartPopup.show();
		});

		this.avery.$on('addToWishlist', (product) => {
			this.wishlistPopup.insertProduct(product);
			this.wishlistPopup.show();
		});

		this.avery.$on('closeAllPopups', () => {
			this.cartPopup.hide();
			this.wishlistPopup.hide();
			this.shoppingPopup.hide();
			this.checkoutPopup.hide();
			this.avery.$emit('startScroll');
		});
		this.avery.$on('viewShoppingCart', () => {
			this.shoppingPopup.show();
		});

		this.avery.$on('viewCheckout', () => {
			this.checkoutPopup.show();
		});
		this.avery.$on('updateUi', () => {
			this.cartBagElement.updateUi();
			this.shoppingPopup.updateUi();
			this.checkoutPopup.updateUi();
		});
	}

	// onPreloaded() {
	// 	if (this.scrollOnLoad) {
	// 		this.scroll.scrollTo(this.scrollOnLoad);
	// 		this.scrollOnLoad = null;
	// 	}
	// 	this.loader.preloader.hide();
	// 	this.navigation.updateNav(this.loader.template);
	// 	NodeEmitter.emit('showMenu');
	// 	// if (this.loader.template === 'home')
	// 	// 	this.home.components.selection.getBounds();
	// 	if (this.loader.template === 'designs') {
	// 		this.designs.components.designProcess.on('stopScroll', () =>
	// 			this.scroll.stop()
	// 		);
	// 		this.designs.components.designProcess.on('startScroll', () =>
	// 			this.scroll.start()
	// 		);
	// 	}
	// }

	update(time) {
		if (this.scroll) {
			this.scroll.raf(time);
			// this.scroll.on('scroll', ScrollTrigger.update);
		}

		this.frame = window.requestAnimationFrame(this.update.bind(this));
	}

	addEventListeners() {
		window.addEventListener('resize', debounce(this.onResize.bind(this))); // runs on the next frame
	}

	onResize() {
		this.avery.loader.current.page.onResize();
		if (this.footer) {
			this.footer.onResize();
		}
	}

	getCurrentLocale() {
		const currentPath = window.location.pathname;
		const normalizeUrl = (url) => {
			return url.endsWith('/') ? url.slice(0, -1) : url;
		};
		// Create a regex pattern from the LOCALES array
		const localePattern =
			LOCALES && LOCALES.length > 0
				? LOCALES.map((locale) => locale.code).join('|')
				: [];
		const regex = new RegExp(`^/(${localePattern})(/.*)?$`);

		// Extract locale and path
		const extractLocaleAndPath = (url) => {
			const match = url.match(regex);
			return match
				? { locale: match[1], path: normalizeUrl(match[2] || '/') }
				: { locale: '', path: normalizeUrl(url) };
		};

		let current = extractLocaleAndPath(currentPath);
		if (!current.locale) {
			current.locale = 'ua'; // Default locale
		}

		console.log('👽', current);
		window.locale = current.locale;
		console.log(STOREPRODUCTS, STORESIZES);
	}
}

new App();
